import { LookUpCodes } from './lov';

export class CreateCustomer {
    customers?: Customers;
}

export class CustomerResponse {
    customers?: Customers[] = [];
    requestIdentifier?: string;
    transactionDate?: string;
    success?: string;
    paging?: Paging;
}

export class Customers {
    trans_uuid?: string;
    id?: number;
    userName?: string;
    customerId?: number;
    customerCode?: string;
    customerName?: string;
    enrollmentType?: string;
    outboundInterface?: OutboundInterface[];    
    outboundInterfaces?: OutboundInterface[];
    notification?: Notification[];    
    notifications?: Notification[];
    active?: boolean;
    creationDate?: string;
    businessUnits?: BusinessUnits[] = [];
    returnLabelOverride? : String = "";
    returnShipmentFlag? : String ="";
    returnShipmentType? : String ="";
    returnLabelprintGenerate?: [];
    returnLabelType? :[];
    consolidatedBusinessUnits?: ConsolidatedBusinessUnit[] = [];
    categories?: Categories[] = [];
    productType?: LookUpCodes[];
    orderType?: LookUpCodes[];
    valueAddedServiceName?: LookUpCodes[];
    uom?: LookUpCodes[];
    Retailers?:LookUpCodes[];
    productClass?: LookUpCodes[];
    packingSlip?: packingSlip[];
    packingSlips?: packingSlip[];
    shippingLabel?: shippingLabel[];
    shippingLabels?: shippingLabel[];
    userId?: string;
    dynamicSlotAttr?: LookUpCodes[];
    vendorID?:string;
    vendorName?:string;
    vendorNumber?:string;
    vendorInfo?:string;
    documentgeneration?: LookUpCodes[]; // B-2452615 - BedRock Feature
    shipmentMethod?: string; // B-2452615 - BedRock Feature
}

export class packingSlip {
    orderType?: string;
    retailerName?: string;
    packingSlipType?: string;
    active?: boolean;
}

export class shippingLabel {
    orderType?: string;
    retailerName?: string;
    shippingLabelType?: string;
    active?: boolean;
}

export class OutboundInterface {
    outboundInterfaceName?: string;
    outboundInterfaceType?: string;
    active?: boolean;
}

export class Notification {
    notificationName?: string;
    notificationType?: string;
    email?: string;
    active?: boolean;
}

export class BusinessUnits {
    buId?: number;
    businessUnitCode?: string;
    businessUnitName?: string;
    customerEIN?: string;
    active?: boolean;
    createdBy?: string;
    contacts?: Contacts[] = [];
    facilities?: Facilities[] = [];
    addressInformation?: AddressInformation;
    additionalAddresses?: AdditionalAddress[] = [];
    additionalAddresseses?: AdditionalAddress[] = [];
}

export class AdditionalAddress {
    addressId?: number;
    addressCode?: string;
    customerEin?: string;
    addrActive?: string;
    isDeleted?: boolean;
    contactName?: string;
    phone?: string;
    email?: string;
    secondaryContactName?: string;
    secondaryPhone?: string;
    secondaryEmail?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
}
export class Contacts {
    contactName?: string;
    phone?: string;
    email?: string;
    primaryContact?: boolean;
    creationDate?: string;
}

export class Facilities {
    facilityName?: string;
    facilityID?: number;
    creationDate?: string;
    active?: boolean;
    serviceType: string;
    applicationType?: string;
}

export class Categories {
    type?: string;
    value?: string;
    active?: boolean;
    creationDate?: string;
    customerCategoryDetails?: CustomerCategoryDetail[];
}
export class CustomerCategoryDetail {
    retailerName?: string;
    retailerValue?: string;
    labelType?: string;
    labelValue?: string;
    Retailers?:any;
}
export class Paging {
    last?: boolean;
    first?: boolean;
    totalPages?: number;
    totalElements?: number;
    size?: number;
    number?: number;
    numberOfElements?: number;
    next?: string;
}

export class ConsolidatedBusinessUnit {
    businessUnitCode?: string;
    businessUnitName?: string;
    customerEIN?: string;
    buActive?: boolean;
    contactName1?: string;
    contactName2?: string;
    phoneNumber1?: string;
    phoneNumber2?: string;
    emailId1?: string;
    emailId2?: string;
    facilities?: string;
    addressInformation?: AddressInformation;
    destinationFacility?: Facilities[];
    additionalAddresses?: AdditionalAddress[];
}
export class AddressInformation {
    name?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
}

export class ValidateCustomers {
    items: string[];
    transactionDate: string;
    success: boolean;
}
export class selectedCust{
    custId?: string;
    buId?: string;
    fcyId?: string;
}

export class CredentialsSearchParam {
    custId: string;
    buId: string;
    fcyId: string;
    page?: string;
    pageSize?: string;
    responseFilter?: string;
    orderType?: string;
    routeTo?: string;
    accountType?: string;
    shipType?: string;
    shipment?: string;
    applyPriority?: boolean;
    provider?: string;
    serviceCode?: string;
    carrierNames?: string[];
    status?: string;
    configGroupId?: string;
}

export class CustomerCarrierAccResponse {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    errors?: Errors;
    paging?: Pagination;
    data?: CustomerCarrierAccountData[];
}
export class Errors {
    errorMessage?: string;
    exceptionResponse: ErrorCode[];
}
export class ErrorCode {
    code?: string;
    description?: string;
}
export class Pagination{
    last: boolean;
    first: boolean;
    totalPages: number;
    totalElements: number;
    size: number;
    number: number;
    numberOfElements: number;
}

export class AddressMapping {
    configGroupId?: number;
    custId?: number;
    buId?: number;
    attributeName?: string;
    attributeVals?: string[];
    documentTypes?: string[];
    addressRoles?: string[];
    addressCode?: string;
    active?: string;
    deleted?: string;
}

export class AddressMappingRequest {
    updateType?: string;
    addressMappings?: AddressMapping[];
}

export class AddressMappingResponse {
    requestIdentifier?: string;
    transactionDate?: string;
    success?: boolean;
    message?: string;
    addressMappings?: AddressMapping[];
    errors?: Errors;
}

export class CustomerCarrierAccountData {
    custId?: string;
    buId?: string;
    fcyId?: string;
    provider?: string;
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
    rteTo?: string;
    orderType?: string;
    orderTypes?: string[];
    shipType?: string;
    accountType?: string;
    country?: string;
    postalCode?: string;
    configGroupId?: string;
    active?: string;
    providerServices?: string;
    shipment?: string;
    credentials?: CredentialDTO[];
    carrierAccountDetails?: CarrierAccountDetailDTO[];
}

export class CredentialDTO {
    credentialsType?: string;
    credentialsKey?: string;
    credentialsPassword?: string;
    accountNumber?: string;
    meterNumber?: number;
    apiKey?: string;
    billingAccountNumber?: string;
}

export class CarrierAccountDetailDTO {
    custCarrAccountDetId?: number;
    carrierName?: string;
    carrierExtAccountId?: string;
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
    carrierDetailServices?: CarrierAccountDetailServiceDTO[];
}

export class CarrierAccountDetailServiceDTO {
    carrierDtlServiceId?: number;
    carrierServicesId?: string;
    serviceCode?: string;
    serviceDescription?: string;
    active?: string;
    providerServiceValue?: string;
    carrierCode?: string;
    providerCarrierValue?: string;
    carrierDescription?: string;
    createdTime?: string;
    createdBy?: string;
    lastUpdatedTime?: string;
    lastUpdatedBy?: string;
}

export class CarrierAccountCreateReq {
    carrierAccounts?: CarrierAccountReq[];
}

export class CarrierAccountReq {
    custId?: string;
    buId?: string;
    fcyId?: string;
    provider?: string;
    routeTo?: string;
    accountType?: string;
    country?: string;
    postalCode?: string;
    active?: string;
    providerServices?: string;
    shipType?: string;
    shipment?: string;
    credentials?: CredentialDTO[];
    orderTypes?: string[];
    carrierAccountDetails?: CarrierAccountDetailDTO[];
    custCarrierAccountId?: number;
}

export class CustomerCredentialRes {
    messageCode?: string;
    message?: string;
}